module.exports = __webpack_public_path__ + "media/images/btn_login-7be6f7b42ff6369534adbea524447bd4.gif";